import { useState } from "react";
import { Flex, Box } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import { isFreemium } from "src/modules/auth/duck/selectors";
import { usePurchaseContext } from "src/modules/purchase/PurchaseContext";
import NavigationBar from "src/components/NavigationBar";
import { ReactComponent as DeleteIcon } from "src/icons/delete-outlined.svg";
import AvatarPreview from "../AvatarPreview";
import CategorySelect from "../CategorySelect";
import Bio from "./components/Bio";
import Skin from "./components/Skin";
import Face from "./components/Face";
import Dress from "./components/Dress";
import Accessories from "./components/Accessories";

const Categories = {
  Bio: 0,
  Skin: 1,
  Face: 2,
  Dress: 3,
  Accessories: 4
};
const Previews = {
  Sleeping: 0,
  Awake: 1
};

export default function BabyView({
  avatar,
  onSubmit,
  onClose,
  onBack,
  onDelete,
  onInputChange,
  onSkinSelect,
  handleAvatarStyleUpdate,
  changeAvatarMode,
  onAvatarSelection,
  croppedAvatar,
  t,
  ...rest
}) {
  const { name, objectId } = avatar;
  const [category, setCategory] = useState(Categories.Bio);
  const [avatarPreview, setAvatarPreview] = useState(Previews.Sleeping);
  const isSleeping = avatarPreview === Previews.Sleeping;

  const isFreeVersion = useSelector(isFreemium);
  const purchase = usePurchaseContext();

  const Components = {
    [Categories.Bio]: (
      <Bio
        {...rest}
        croppedAvatar={croppedAvatar}
        onAvatarSelection={onAvatarSelection}
        avatar={avatar}
        t={t}
        onInputChange={onInputChange}
      />
    ),
    [Categories.Skin]: (
      <Skin
        handleAvatarStyleUpdate={handleAvatarStyleUpdate}
        avatar={avatar}
        onSkinSelect={onSkinSelect}
        t={t}
      />
    ),
    [Categories.Face]: (
      <Face
        handleAvatarStyleUpdate={
          isFreeVersion
            ? () => purchase.open({ content: "editor" })
            : handleAvatarStyleUpdate
        }
        avatar={avatar}
        isSleeping={isSleeping}
        t={t}
      />
    ),
    [Categories.Dress]: (
      <Dress
        handleAvatarStyleUpdate={
          isFreeVersion
            ? () => purchase.open({ content: "editor" })
            : handleAvatarStyleUpdate
        }
        avatar={avatar}
        t={t}
      />
    ),
    [Categories.Accessories]: (
      <Accessories
        handleAvatarStyleUpdate={
          isFreeVersion
            ? () => purchase.open({ content: "editor" })
            : handleAvatarStyleUpdate
        }
        avatar={avatar}
        t={t}
      />
    )
  };
  return (
    <>
      <NavigationBar
        headingKey="avatar.editAvatar"
        actionButton={{
          labelKey: "buttons.save",
          form: "avatar.editor",
          type: "submit",
          disabled: name === ""
        }}
        actionIcon={
          objectId
            ? {
                onClick: onDelete,
                icon: DeleteIcon
              }
            : null
        }
        onBack={onBack}
        onClose={onClose}
      />
      <Flex
        width="100%"
        px="12px"
        as="form"
        id="avatar.editor"
        onSubmit={onSubmit}
        height="calc(100% - 61px)"
      >
        <AvatarPreview
          mt="16px"
          mr="24px"
          avatar={avatar}
          Previews={Previews}
          handlePreviewChange={(newPreview) => setAvatarPreview(newPreview)}
          preview={avatarPreview}
          isSleeping={isSleeping}
          changeAvatarMode={changeAvatarMode}
          onAvatarSelection={onAvatarSelection}
          croppedAvatar={croppedAvatar}
          t={t}
        />
        <Box mt="16px" width="100%">
          <CategorySelect
            t={t}
            selectedCategory={category}
            categories={Object.entries(Categories)}
            onSelect={(category) => setCategory(category)}
          />
          {Components[category]}
        </Box>
      </Flex>
    </>
  );
}
